import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import '../../scss/news-styling-component/news-search.style.scss';
import { useTranslation } from 'react-i18next';

interface SearchInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  onSubmit?: (e: React.FormEvent) => void;
  iconSrc?: string;
  altText?: string;
  className?: string;
  inputClassName?: string;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder,
  onSubmit,
  iconSrc,
  altText,
  className = '',
  inputClassName = ''
}) => {
  const { t } = useTranslation();

  return (
    <Form onSubmit={onSubmit} className={`search-input-form ${className}`}>
      <InputGroup className="search-input-group">
        <Form.Control
          type="text"
          placeholder={placeholder || t("SEARCH_PLACEHOLDER")}
          value={value}
          onChange={onChange}
          className={`search-input ${inputClassName}`}
        />
        {iconSrc && (
          <span className="search-input-icon mt-2">
            <img
              src={iconSrc}
              alt={altText || t("ALT_SEARCH")}
              width="20"
              height="20"
            />
          </span>
        )}
      </InputGroup>
    </Form>
  );
};
